const baseTitles = {
  source: 'Source',
  locationTime: 'Location Time',
  estimatedAddress: 'Estimated Address - VERIFY',
  latitude: 'Latitude',
  longitude: 'Longitude',
  what3words: 'What3Words',
  altitude: 'Altitude',
  uncertaintyRadius: 'Uncertainty Radius',
};

const alertTitles = {
  ...baseTitles,
  alertID: 'Alert ID',
  alertType: 'Alert Type',
  verticalUncertainty: 'Vertical Uncertainty',
  estimatedFloorLevel: 'Estimated Floor Level',
};

const callTitles = {
  ...baseTitles,
  callerID: 'Caller ID',
  estimatedAddressProvider: 'Estimated Address Provider',
  estimatedFloor: 'Estimated Floor',
  altitudeUncertaintyRadius: 'Altitude Uncertainty Radius',
  uncertaintyConfidence: 'Uncertainty Confidence',
};

/**
 * returns a formatted string with copied info
 *
 * @param {object} locationData - object is formed in CopyAllButton.js or AlertCopyAllButton.js and it has the following keys:
 * callerID, alertID, source, locationTime, estimatedAddress, address, estimatedFloor, latitude, longitude, what3words, altitude, altitudeUncertaintyRadius, uncertaintyRadius, uncertaintyConfidence
 * @returns string
 */
export const handleClipboardData = locationData => {
  let str = '';
  const readableTitles = locationData.callerID ? callTitles : alertTitles;

  Object.keys(locationData).forEach(i => {
    if (locationData[i]) {
      const lineExpression = `${readableTitles[i]}: ${locationData[i]}`;
      str += str === '' ? lineExpression : `\n${lineExpression}`;
    }
  });
  return str;
};
